export interface RoomComment {
  id: string;
  comment: string;
  authorId: string;
  createdAt: string;
}

export interface SourceRoom {
  id: string;
  externalId: string;
  externalPropertyId: string;
  name: string;
  description: string;
  supplier: App.Bedbank.Suppliers;
  amenities: Array<string>;
  bedGroups: Array<{
    id: string;
    description: string;
    configuration: Array<{
      type: string;
      size: string;
      quantity: number;
    }>;
  }>;
  views?: Array<string>;
  characteristic?: string;
  occupancy?: any;
  sourceContent?: any;
  roomSize?: number;
  availabilityScore?: number;
  availabilityScoreUpdatedAt?: string;
  hasInfo: boolean;
  isAutoMappingEnabled: boolean;
  comments?: Array<RoomComment>;
}

export interface SourceRoomGroup {
  type: 'group';
  supplier: App.Bedbank.Suppliers;
  supplierRoomName: string;
  rooms: Array<SourceRoom>;
}

export type SourceRoomListItem = SourceRoom | SourceRoomGroup;

export function isSourceRoomGroup(room: SourceRoomListItem): room is SourceRoomGroup {
  return (room as SourceRoomGroup).type === 'group';
}

export interface AutomappingFlagToggleTarget {
  supplierRoomId: string;
  externalPropertyId: string;
  supplier: App.Bedbank.Suppliers;
  isAutoMappingEnabled: boolean;
}

export interface PropertyRoom {
  nameOverride?: string;
  status?: string;
  id: string;
  name: string;
  description: string;
  externalId: string | undefined;
  mappedRooms: Array<MappedRoom>;
  supplier: App.Bedbank.Suppliers;
}

export interface MappingChange {
  supplier: App.Bedbank.Suppliers;
  externalId: string;
  isVerified?: boolean;
}
export interface MappedRoom {
  id: string;
  externalPropertyId: string;
  externalId: string;
  supplier: App.Bedbank.Suppliers;
  isVerified: boolean;
  roomId: string;
  mappingMethod?: Array<'manual' | 'sync' | 'string' | 'vervotech' | 'gimmonix' | 'import' | 'ml' | 'ml_jaccard'>;
  /** Format: ISO8601 */
  updatedAt?: string;
  sourceContent: SourceRoom | undefined;
  comments?: Array<RoomComment>;
}

export interface MappedRoomGroup {
  type: 'group';
  supplier: App.Bedbank.Suppliers;
  supplierRoomName: string;
  rooms: Array<MappedRoom>;
}

export type MappedRoomListItem = MappedRoom | MappedRoomGroup;

export function isMappedRoomGroup(room: MappedRoomListItem): room is MappedRoomGroup {
  return (room as MappedRoomGroup).type === 'group';
}

export interface RoomScore {
  roomName: string;
  score: number;
}
